<template>
  <div
    style="
      width: 1667px;
      height: 879px;
      background: url('./static/images/bgcch.jpg') !important;
      background-size: 100% !important;
      background-repeat: no-repeat;
      position: relative;
    "
  >
    <el-alert
      v-if="!mibeeOnline"
      :title="errortext"
      type="error"
      :closable="false"
      effect="dark"
      show-icon
    >
    </el-alert>
    <div
      v-if="qlg.power == 1 && mibeeOnline"
      style="
        width: 100%;
        height: 100%;
        background: url('./static/images/icon/runcch.gif');
        background-size: 100% 100%;
      "
    ></div>
    <div
      style="
        color: #ffffff;
        font-size: 16px;
        position: absolute;
        top: 50px;
        left: 260px;
      "
    >
      室内环境
    </div>
    <div
      style="
        color: #ffffff;
        font-size: 16px;
        position: absolute;
        top: 50px;
        left: 790px;
      "
    >
      全联供空调
      <span v-if="!qlg.online" style="color: red; font-size: 12px">离线</span>
    </div>
    <div
      v-if="false"
      style="
        color: red;
        font-size: 14px;
        position: absolute;
        top: 30px;
        left: 1290px;
      "
    >
      <i class="el-icon-warning"></i> 主机离线，最后更新时间：<span
        style="color: #929292"
        >{{ uploadtime || qlg.uploadtime }}</span
      >
    </div>
    <div
      style="
        color: #ffffff;
        font-size: 16px;
        position: absolute;
        top: 270px;
        left: 1340px;
      "
    >
      室外机
      <span v-if="!heatpump.online" style="color: red; font-size: 12px"
        >离线</span
      >
    </div>
    <div
      style="
        color: #15d04c;
        font-size: 12px;
        position: absolute;
        top: 185px;
        left: 1170px;
      "
    >
      耗电监控
    </div>
    <div
      style="
        color: #ffffff;
        font-size: 12px;
        position: absolute;
        top: 205px;
        left: 1170px;
        text-align: left;
        line-height: 20px;
        width: 365px;
      "
    >
     <el-col :span="8" class="text_big">昨日耗电</el-col>
      <el-col :span="3" :offset="1" class="value_big">{{power.length>=2?Math.round(power[0].powerused):0}}度</el-col>
       <el-col :span="7" :offset="1" class="text_big">当前功率</el-col>
      <el-col :span="3" :offset="1" class="value_big">{{Math.round(acb.voltage*acb.elecrt)||0}}W</el-col>
       <el-col :span="8" class="text_big">今日耗电</el-col>
        <el-col :span="3" :offset="1" class="value_big">{{power.length>=2?Math.round(power[1].powerused):0}}度</el-col>
         <el-col :span="7" :offset="1" class="text_big">当前电流</el-col>
        <el-col :span="3" :offset="1" class="value_big">{{acb.elecrt||0}}A</el-col>
    </div>
    <div
      style="
        color: #15d04c;
        font-size: 12px;
        position: absolute;
        top: 55px;
        left: 1170px;
      "
    >
      气象站
    </div>
    <div
      style="
        color: #ffffff;
        font-size: 12px;
        position: absolute;
        top: 45px;
        left: 1220px;
        height: 120px;
        line-height: 20px;
        text-align: left;
        width: 360px;
      "
    >
      <el-col :span="4" class="text_big">室外温度</el-col>
      <el-col :span="2" class="value_big">{{ outtemp }}℃</el-col>
      <el-col :span="4" :offset="1" class="text_big">室外湿度</el-col>
      <el-col :span="2" class="value_big">{{ outhumid }}%</el-col>
      <el-col :span="4" :offset="1" class="text_big">含湿量</el-col>
      <el-col :span="2" class="value_big"
        >{{ calcHsl(outtemp, outhumid) }}g/Kg</el-col
      >
      <el-col :span="5" class="text_big">空气焓值</el-col>
      <el-col :span="2" class="value_big"
        >{{ calcHanZhi(outtemp, outhumid) }}Kj/Kg</el-col
      >
      <el-col :span="5" :offset="5" class="text_big">空气质量指数</el-col>
      <el-col :span="3" :offset="1" class="value_big"
        >{{ aqi }} ({{ aqilevel }})</el-col
      >
    </div>

    <div
      style="
        color: #15d04c;
        font-size: 12px;
        position: absolute;
        top: 320px;
        left: 1190px;
      "
    >
      系统参数
    </div>
    <div
      style="
        color: red;
        font-size: 14px;
        position: absolute;
        top: 270px;
        left: 1390px;
        height: 20px;
        line-height: 20px;
      "
      class="el-icon-warning"
      v-if="heatpump.errmsg&&heatpump.errmsg!='未知故障'"
    >
      {{ heatpump.errmsg }}
    </div>
    <el-button
      size="mini"
      type="info"
      style="
        position: absolute;
        top: 268px;
        left: 1470px;
        height: 25px;
        background: #000000;
        border: 0;
      "
      @click="dialogTableVisible = true"
      >故障记录</el-button
    >
    <div
      style="
        color: #15d04c;
        font-size: 12px;
        position: absolute;
        top: 435px;
        left: 1190px;
      "
    >
      氟机工况
    </div>
    <div
      style="
        color: #15d04c;
        font-size: 12px;
        position: absolute;
        top: 640px;
        left: 1190px;
      "
    >
      热泵工况
    </div>
    <div
      v-if="!!!qlg.hffjzs || !mibeeOnline || !!!qlg.power"
      style="
        z-index: 1;
        position: absolute;
        width: 30px;
        height: 30px;
        top: 440px;
        left: 857px;
        background: url('./static/images/icon/stopfanset.png');
        background-size: 100% 100%;
      "
    ></div>
    <div
      v-else
      style="
        z-index: 1;
        position: absolute;
        width: 30px;
        height: 30px;
        top: 440px;
        left: 857px;
        background: url('./static/images/icon/runfanset.gif');
        background-size: 100% 100% !important;
      "
    ></div>

    <div
      v-if="!!!qlg.xffjzs || !mibeeOnline || !!!qlg.power"
      style="
        z-index: 1;
        position: absolute;
        width: 40px;
        height: 40px;
        top: 673px;
        left: 736px;
        background: url('./static/images/icon/stopfanset.png');
        background-size: 100% 100%;
      "
    ></div>
    <div
      v-else
      style="
        z-index: 1;
        position: absolute;
        width: 40px;
        height: 40px;
        top: 673px;
        left: 736px;
        background: url('./static/images/icon/runfanset.gif');
        background-size: 100% 100% !important;
      "
    ></div>

    <!-- <div style="width:1667px;height:880px; background: url('../../static/images/icon/stopfanset.png'); background-size: 100% 100%;"></div> -->
    <el-row
      style="
        font-size: 12px;
        position: absolute;
        top: 80px;
        left: 90px;
        width: 420px;
        height: 745px;
        text-align: left;
        overflow: hidden;
        overflow-y: auto;
      "
    >
      <el-col
        :span="24"
        style="
          position: relative;
          background: #141517;
          border-radius: 20px;
          height: 160px;
          margin-top: 20px;
        "
        v-for="item in devicelist.filter((x) => {
          return (
            x.protocolid == 151
          );
        })"
        :key="item.innerid"
      >
        <div
          style="
            color: #ffffff;
            font-size: 13px;
            position: relative;
            top: 0px;
            left: 0px;
            height: 50px;
            width: 100%;
            line-height: 50px;
            padding-left: 30px;
          "
        >
          {{ item.roomname }}
        </div>
        <div
          style="
            color: #15d04c;
            font-size: 12px;
            position: absolute;
            top: 5px;
            left: 273px;
          "
          v-if="item.devtype == 2"
        >
          风盘
        </div>
        <div
          style="
            color: #15d04c;
            font-size: 12px;
            position: absolute;
            top: 5px;
            left: 260px;
          "
          v-else
        >
          顶冷阀门
        </div>

        <div
          class="value"
          style="
            font-size: 12px;
            position: absolute;
            top: 25px;
            left: 260px;
            width: 50px;
            text-align: center;
          "
          v-if="item.devtype == 2"
        >
          {{ getDpText(item, "fanrun") }}
        </div>
        <div
          class="value"
          style="
            font-size: 12px;
            position: absolute;
            top: 25px;
            left: 260px;
            width: 50px;
            text-align: center;
          "
          v-else
        >
          {{item.fsvalneed?'通':'断'}}
        </div>

        <div
          style="
            color: #15d04c;
            font-size: 12px;
            position: absolute;
            top: 5px;
            left: 340px;
          "
        >
          控制器
          <span v-if="!item.online" style="color: red; font-size: 12px"
            >离线</span
          >
        </div>
        <div
          class="value"
          style="
            font-size: 12px;
            position: absolute;
            top: 25px;
            left: 340px;
            width: 40px;
            text-align: center;
          "
        >
          {{ getDpText(item, "power") }}
        </div>
        <div
          style="
            position: relative;
            background: #000002;
            width: 90%;
            height: 90px;
            left: 5%;
            border-radius: 20px;
          "
        >
          <el-row
            style="
              position: absolute;
              top: 15px;
              left: 10px;
              width: 155px;
              height: 80px;
              text-align: left;
            "
          >
            <el-col :span="12" class="text_big">设定温度</el-col>
            <el-col :span="8" :offset="1" class="value_big"
              >{{ item.settemp.toFixed(1) }}℃</el-col
            >
            <el-col :span="12" class="text_big">室内温度</el-col>
            <el-col :span="8" :offset="1" class="value_big"
              >{{ item.temp.toFixed(1) }}℃</el-col
            >
            <el-col :span="12" class="text_big">露点温度</el-col>
            <el-col :span="8" :offset="1" class="value_big"
              >{{ item.dewtemp.toFixed(1) }}℃</el-col
            >
          </el-row>
          <el-row
            style="
              position: absolute;
              top: 15px;
              left: 215px;
              width: 155px;
              height: 80px;
              text-align: left;
            "
          >
            <el-col :span="12" class="text_big">湿度</el-col>
            <el-col :span="8" :offset="1" class="value_big"
              >{{ item.snrhumi }}%</el-col
            >
            <el-col :span="12" class="text_big">湿量</el-col>
            <el-col :span="8" :offset="1" class="value_big">
              {{ calcHsl(item.temp, item.snrhumi) }}g/Kg</el-col
            >
            <el-col :span="12" class="text_big">焓值</el-col>
            <el-col :span="8" :offset="1" class="value_big"
              >{{ calcHanZhi(item.temp, item.snrhumi) }}Kj/Kg</el-col
            >
          </el-row>
        </div>
      </el-col>
    </el-row>

    <!-- 系统参数 -->
    <el-row
      style="
        font-size: 12px;
        position: absolute;
        top: 345px;
        left: 1190px;
        width: 365px;
        height: 145px;
        text-align: left;
      "
    >
      <el-col :span="7" class="text_big">开关机</el-col>
      <el-col :span="3" :offset="1" class="value_big">{{
        getDpText(heatpump, "power")
      }}</el-col>
      <el-col :span="6" :offset="1" class="text_big">设置模式</el-col>
      <el-col :span="4" :offset="1" class="value_big">{{
        getDpText(heatpump, "acmode")
      }}</el-col>
      <el-col :span="6" class="text_big">热水开关</el-col>
      <el-col :span="4" :offset="1" class="value_big">{{
        getDpText(heatpump, "reg5004")
      }}</el-col>
      <el-col :span="7" :offset="1" class="text_big">生活热水设置温度</el-col>
      <el-col :span="3" :offset="1" class="value_big"
        >{{ heatpump.hwsettemp }}℃</el-col
      >
      <el-col :span="7" class="text_big">相对湿度设置</el-col>
      <el-col :span="3" :offset="1" class="value_big"
        >{{ heatpump.sethumi }}%</el-col
      >
    </el-row>
    <!-- 氟机 -->
    <el-row
      style="
        font-size: 12px;
        position: absolute;
        top: 460px;
        left: 1190px;
        width: 365px;
        height: 145px;
        text-align: left;
      "
    >
      <el-col :span="7" class="text_big">开关机</el-col>
      <el-col :span="3" :offset="1" class="value_big">{{
        getDpText(heatpump, "power")
      }}</el-col>
      <el-col :span="6" :offset="1" class="text_big">运行状态</el-col>
      <el-col :span="4" :offset="1" class="value_big">{{
        getDpText(heatpump, "runmode2")
      }}</el-col>
      <el-col :span="7" class="text_big">制冷回风设置温度</el-col>
      <el-col :span="3" :offset="1" class="value_big"
        >{{ heatpump.settemp_cf }}℃</el-col
      >
      <el-col :span="7" :offset="1" class="text_big">制热回风设置温度</el-col>
      <el-col :span="3" :offset="1" class="value_big"
        >{{ heatpump.settemp_hf }}℃</el-col
      >
      <el-col :span="7" class="text_big">风机实际转速</el-col>
      <el-col :span="3" :offset="1" class="value_big"
        >{{ heatpump.reg10 }}rpm</el-col
      >
      <el-col :span="7" :offset="1" class="text_big">压缩机频率</el-col>
      <el-col :span="3" :offset="1" class="value_big"
        >{{ heatpump.fjysjpl }}Hz</el-col
      >
      <el-col :span="7" class="text_big">吸气温度</el-col>
      <el-col :span="3" :offset="1" class="value_big"
        >{{ heatpump.reg12 }}℃</el-col
      >
      <el-col :span="7" :offset="1" class="text_big">吸气压力</el-col>
      <el-col :span="3" :offset="1" class="value_big"
        >{{ heatpump.reg80 }}bar</el-col
      >
      <el-col :span="7" class="text_big">吸气过热度</el-col>
      <el-col :span="3" :offset="1" class="value_big"
        >{{ heatpump.reg01 }}℃</el-col
      >
      <el-col :span="7" :offset="1" class="text_big">排温温度</el-col>
      <el-col :span="3" :offset="1" class="value_big"
        >{{ heatpump.reg11 }}℃</el-col
      >
      <el-col :span="7" class="text_big">室内再热中盘温度</el-col>
      <el-col :span="3" :offset="1" class="value_big"
        >{{ heatpump.reg69 }}℃</el-col
      >
      <el-col :span="7" :offset="1" class="text_big">室内除湿中盘温度</el-col>
      <el-col :span="3" :offset="1" class="value_big"
        >{{ heatpump.reg70 }}℃</el-col
      >
      <el-col :span="7" class="text_big">室内膨胀阀1开度</el-col>
      <el-col :span="3" :offset="1" class="value_big"
        >{{ heatpump.reg64 }}步</el-col
      >
      <el-col :span="7" :offset="1" class="text_big">室内膨胀阀2开度</el-col>
      <el-col :span="3" :offset="1" class="value_big"
        >{{ heatpump.reg84 }}步</el-col
      >
      <el-col :span="7" class="text_big">室外膨胀阀3开度</el-col>
      <el-col :span="3" :offset="1" class="value_big"
        >{{ heatpump.reg09 }}步</el-col
      >
      <el-col :span="7" :offset="1" class="text_big">热水水箱温度</el-col>
      <el-col :span="3" :offset="1" class="value_big"
        >{{ heatpump.hwtemp }}℃</el-col
      >
    </el-row>
    <!-- 热泵 -->
    <el-row
      style="
        font-size: 12px;
        position: absolute;
        top: 665px;
        left: 1190px;
        width: 365px;
        height: 165px;
        text-align: left;
      "
    >
      <el-col :span="7" class="text_big">开关机</el-col>
      <el-col :span="3" :offset="1" class="value_big">{{
        getDpText(heatpump, "power")
      }}</el-col>
      <el-col :span="6" :offset="1" class="text_big">运行状态</el-col>
      <el-col :span="4" :offset="1" class="value_big">{{
        getDpText(heatpump, "runmode1")
      }}</el-col>
      <el-col :span="7" class="text_big">制冷出水设置温度</el-col>
      <el-col :span="3" :offset="1" class="value_big"
        >{{ heatpump.settemp_co }}℃</el-col
      >
      <el-col :span="7" :offset="1" class="text_big">制热出水设置温度</el-col>
      <el-col :span="3" :offset="1" class="value_big"
        >{{ heatpump.settemp_ho }}℃</el-col
      >
      <el-col :span="7" class="text_big">风机转速</el-col>
      <el-col :span="3" :offset="1" class="value_big"
        >{{ heatpump.reg38 }}rpm</el-col
      >
      <el-col :span="7" :offset="1" class="text_big">压缩机频率</el-col>
      <el-col :span="3" :offset="1" class="value_big"
        >{{ heatpump.sjysjpl }}Hz</el-col
      >
      <el-col :span="7" class="text_big">吸气温度</el-col>
      <el-col :span="3" :offset="1" class="value_big"
        >{{ heatpump.reg40 }}℃</el-col
      >
      <el-col :span="7" :offset="1" class="text_big">吸气压力</el-col>
      <el-col :span="3" :offset="1" class="value_big"
        >{{ heatpump.reg75 }}bar</el-col
      >
      <el-col :span="7" class="text_big">吸气过热度</el-col>
      <el-col :span="3" :offset="1" class="value_big"
        >{{ heatpump.reg27 }}℃</el-col
      >
      <el-col :span="7" :offset="1" class="text_big">排温温度</el-col>
      <el-col :span="3" :offset="1" class="value_big"
        >{{ heatpump.reg39 }}℃</el-col
      >

      <el-col :span="7" class="text_big">中盘温度</el-col>
      <el-col :span="3" :offset="1" class="value_big"
        >{{ heatpump.reg41 }}℃</el-col
      >
      <el-col :span="7" :offset="1" class="text_big">出盘温度</el-col>
      <el-col :span="3" :offset="1" class="value_big"
        >{{ heatpump.reg47 }}℃</el-col
      >
      <el-col :span="7" class="text_big">室外膨胀阀1开度</el-col>
      <el-col :span="3" :offset="1" class="value_big"
        >{{ heatpump.reg35 }}步</el-col
      >
      <el-col :span="7" :offset="1" class="text_big">室外膨胀阀2开度</el-col>
      <el-col :span="3" :offset="1" class="value_big"
        >{{ heatpump.reg36 }}步</el-col
      >
      <el-col :span="7" class="text_big">环境温度</el-col>
      <el-col :span="3" :offset="1" class="value_big"
        >{{ heatpump.temp }}℃</el-col
      >
      <el-col :span="7" :offset="1" class="text_big">循环水泵状态</el-col>
      <el-col :span="3" :offset="1" class="value_big">{{
        getDpText(heatpump, "reg37")
      }}</el-col>
    </el-row>
    <!-- 滤网 -->
    <el-row
      style="
        font-size: 13px;
        position: absolute;
        top: 480px;
        left: 600px;
        width: 100px;
        height: 60px;
        text-align: left;
      "
    >
      <el-col :span="13" class="text">滤网已用天数</el-col>
      <el-col :span="7" :offset="1" class="value">--</el-col>
    </el-row>
    <!-- 输配中心 -->
    <el-row
      style="
        font-size: 12px;
        position: absolute;
        top: 275px;
        left: 950px;
        width: 130px;
        height: 60px;
        text-align: left;
      "
    >
      <el-col :span="11" class="text">模式</el-col>
      <el-col :span="10" class="value">{{ getDpText(qlg, "mode") }}</el-col>
      <el-col :span="11" class="text">热泵供水</el-col>
      <el-col :span="10" class="value">{{ heatpump.temp_o }}℃</el-col>
      <el-col :span="11" class="text">热泵回水</el-col>
      <el-col :span="10" class="value">{{ heatpump.temp_b }}℃</el-col>
      <el-col :span="11" class="text">混水供水</el-col>
      <el-col :span="10" class="value">{{ qlg.mixtemp }}℃</el-col>
      <el-col :span="11" class="text">混水回水</el-col>
      <el-col :span="10" class="value">{{ qlg.sphstemp }}℃</el-col>
      <el-col :span="11" class="text">水泵状态</el-col>
      <el-col :span="10" class="value">{{ getDpText(qlg, "spsbzt") }}</el-col>
      <el-col :span="11" class="text">供水压力</el-col>
      <el-col :span="10" class="value">--</el-col>
      <el-col :span="11" class="text">回水压力</el-col>
      <el-col :span="10" class="value">--</el-col>
    </el-row>

    <!-- 室外进风口 -->
    <el-row
      style="
        font-size: 12px;
        position: absolute;
        top: 108px;
        left: 1170px;
        width: 365px;
        height: 30px;
        text-align: left;
      "
    >
      <el-col :span="2" style="color: #ffffff" class="text_big">温度</el-col>
      <el-col :span="2" class="value_big">{{ qlg.extemp }}℃</el-col>
      <el-col :span="2" style="color: #ffffff" :offset="1" class="text_big"
        >湿度</el-col
      >
      <el-col :span="2" class="value_big">{{ qlg.exhumi }}%</el-col>
      <el-col :span="2" style="color: #ffffff" :offset="1" class="text_big"
        >湿量</el-col
      >
      <el-col :span="3" class="value_big"
        >{{ calcHsl(qlg.extemp, qlg.exhumi) }}g/Kg</el-col
      >
      <el-col :span="2" style="color: #ffffff" :offset="1" class="text_big"
        >焓值</el-col
      >
      <el-col :span="2" class="value_big"
        >{{ calcHanZhi(qlg.extemp, qlg.exhumi) }}Kj/Kg</el-col
      >
    </el-row>
    <!-- 室外排风口 -->
    <el-row
      style="
        font-size: 12px;
        position: absolute;
        top: 145px;
        left: 1170px;
        width: 365px;
        height: 30px;
        text-align: left;
      "
    >
      <el-col :span="2" style="color: #ffffff" class="text_big">温度</el-col>
      <el-col :span="2" class="value_big">{{ qlg.oftemp }}℃</el-col>
      <el-col :span="2" style="color: #ffffff" :offset="1" class="text_big"
        >湿度</el-col
      >
      <el-col :span="2" class="value_big">{{ qlg.ofhumi }}%</el-col>
      <el-col :span="2" style="color: #ffffff" :offset="1" class="text_big"
        >湿量</el-col
      >
      <el-col :span="3" class="value_big"
        >{{ calcHsl(qlg.oftemp, qlg.ofhumi) }}g/Kg</el-col
      >
      <el-col :span="2" style="color: #ffffff" :offset="1" class="text_big"
        >焓值</el-col
      >
      <el-col :span="2" class="value_big"
        >{{ calcHanZhi(qlg.oftemp, qlg.ofhumi) }}Kj/Kg</el-col
      >
    </el-row>

    <!-- 室内回风口 -->
    <el-row
      style="
        font-size: 12px;
        position: absolute;
        top: 160px;
        left: 600px;
        width: 120px;
        height: 60px;
        text-align: left;
      "
    >
      <el-col :span="11" class="text">温度</el-col>
      <el-col :span="10" :offset="1" class="value">{{ qlg.temp }}℃</el-col>
      <el-col :span="11" class="text">湿度</el-col>
      <el-col :span="10" :offset="1" class="value">{{ qlg.snrhumi }}%</el-col>
      <el-col :span="11" class="text">湿量</el-col>
      <el-col :span="10" :offset="1" class="value"
        >{{ calcHsl(qlg.temp, qlg.snrhumi) }}g/Kg</el-col
      >
      <el-col :span="11" class="text">焓值</el-col>
      <el-col :span="10" :offset="1" class="value"
        >{{ calcHanZhi(qlg.temp, qlg.snrhumi) }}Kj/Kg</el-col
      >
      <el-col :span="11" class="text">CO₂</el-col>
      <el-col :span="10" :offset="1" class="value">{{ qlg.snrco2 }}ppm</el-col>
      <el-col :span="11" class="text">PM2.5</el-col>
      <el-col :span="10" :offset="1" class="value"
        >{{ qlg["snrpm2.5"] }}ug/m³</el-col
      >
    </el-row>

    <!-- 回风风机 -->
    <el-row
      style="
        font-size: 12px;
        position: absolute;
        top: 450px;
        left: 950px;
        width: 100px;
        height: 60px;
        text-align: left;
      "
    >
      <el-col :span="11" class="text">转速</el-col>
      <el-col :span="10" :offset="1" class="value">{{ qlg.hffjzs }}rpm</el-col>
      <el-col :span="11" class="text">风量</el-col>
      <el-col :span="10" :offset="1" class="value">--</el-col>
    </el-row>

    <!-- 新风风机 -->
    <el-row
      style="
        font-size: 12px;
        position: absolute;
        top: 670px;
        left: 600px;
        width: 90px;
        height: 60px;
        text-align: left;
      "
    >
      <el-col :span="11" class="text">转速</el-col>
      <el-col :span="10" :offset="1" class="value">{{ qlg.xffjzs }}rpm</el-col>
      <el-col :span="11" class="text">风量</el-col>
      <el-col :span="10" :offset="1" class="value">--</el-col>
    </el-row>

    <!-- 全热交换芯 -->
    <el-row
      style="
        font-size: 12px;
        position: absolute;
        top: 540px;
        left: 600px;
        width: 120px;
        height: 60px;
        text-align: left;
      "
    >
      <!-- <el-col :span="14" class="text">新风效率</el-col>
      <el-col :span="7" :offset="1" class="value">{{qlg.fveff}}%</el-col> -->
      <el-col :span="15" class="text_big">温度交换效率</el-col>
      <el-col :span="6" :offset="1" class="value_big"
        >≥{{ calcRate(qlg.extemp, qlg.fpqtemp, qlg.temp) }}%</el-col
      >
      <el-col :span="15" class="text_big">湿度交换效率</el-col>
      <el-col :span="6" :offset="1" class="value_big"
        >≥{{
          calcRate(
            calcHsl(qlg.extemp, qlg.exhumi),
            calcHsl(qlg.fpqtemp, qlg.fpqhumi),
            calcHsl(qlg.temp, qlg.snrhumi)
          )
        }}%</el-col
      >
      <el-col :span="15" class="text_big">全热交换效率</el-col>
      <el-col :span="6" :offset="1" class="value_big"
        >≥{{
          calcRate(
            calcHanZhi(qlg.extemp, qlg.exhumi),
            calcHanZhi(qlg.fpqtemp, qlg.fpqhumi),
            calcHanZhi(qlg.temp, qlg.snrhumi)
          )
        }}%</el-col
      >
    </el-row>
    <!-- 换热器 -->
    <el-row
      style="
        font-size: 12px;
        position: absolute;
        top: 710px;
        left: 950px;
        width: 120px;
        height: 60px;
        text-align: left;
      "
    >
      <el-col :span="11" class="text">温度</el-col>
      <el-col :span="10" :offset="1" class="value">{{ qlg.fpqtemp }}℃</el-col>
      <el-col :span="11" class="text">湿度</el-col>
      <el-col :span="10" :offset="1" class="value">{{ qlg.fpqhumi }}%</el-col>
      <el-col :span="11" class="text">湿量</el-col>
      <el-col :span="10" :offset="1" class="value"
        >{{ calcHsl(qlg.fpqtemp, qlg.fpqhumi) }}g/Kg</el-col
      >
      <el-col :span="11" class="text">焓值</el-col>
      <el-col :span="10" :offset="1" class="value"
        >{{ calcHanZhi(qlg.fpqtemp, qlg.fpqhumi) }}Kj/Kg</el-col
      >
      <el-col :span="13" class="text">预冷阀门</el-col>
      <el-col :span="8" :offset="1" class="value">{{getDpText(qlg,'hkneed')}}</el-col>
    </el-row>
    <!-- 室内新风口 -->
    <el-row
      style="
        font-size: 12px;
        position: absolute;
        top: 740px;
        left: 600px;
        width: 110px;
        height: 60px;
        text-align: left;
      "
    >
      <el-col :span="11" class="text">温度</el-col>
      <el-col :span="10" :offset="1" class="value">{{ qlg.fphtemp }}℃</el-col>
      <el-col :span="11" class="text">湿度</el-col>
      <el-col :span="10" :offset="1" class="value">{{ qlg.fphhumi }}%</el-col>
      <el-col :span="11" class="text">湿量</el-col>
      <el-col :span="10" :offset="1" class="value"
        >{{ calcHsl(qlg.fphtemp, qlg.fphhumi) }}g/Kg</el-col
      >
      <el-col :span="11" class="text">焓值</el-col>
      <el-col :span="10" :offset="1" class="value"
        >{{ calcHanZhi(qlg.fphtemp, qlg.fphhumi) }}Kj/Kg</el-col
      >
    </el-row>
    <el-dialog
      title="故障历史 (最近100条)"
      :visible.sync="dialogTableVisible"
      width="400px"
    >
      <el-table
        :data="gridData"
        stripe
        border
        height="250"
        :header-cell-style="{ padding: '2px' }"
        :cell-style="{ padding: '5px' }"
      >
        <el-table-column property="createdtime" label="日期"></el-table-column>
        <el-table-column property="errmsg" label="故障内容"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'Device',
  data () {
    return {
      project: {},
      mibeeOnline: false,
      onlineTimeout: null,
      uploadtime: null,
      errorlist: [],
      devicelist: [],
      outtemp: null,
      outhumid: null,
      aqi: null,
      dialogTableVisible: false,
      gridData: [],
      power: {}
    }
  },
  computed: {
    errortext: function () {
      return (
        '当前miBEE主机离线，页面展示数据最后更新时间为：' +
        (this.uploadtime || (this.qlg ? this.qlg.uploadtime : ''))
      )
    },
    aqilevel: function () {
      if (this.aqi <= 50) {
        return '优'
      } else if (this.aqi <= 100) {
        return '良'
      } else if (this.aqi <= 150) {
        return '轻度污染'
      } else if (this.aqi <= 200) {
        return '中度污染'
      } else if (this.aqi <= 300) {
        return '重度污染'
      } else {
        return '严重污染'
      }
    },
    // 全联供空调
    qlg: function () {
      let dev = this.devicelist.filter((d) => {
        return d.protocolid == 150
      })
      if (dev && dev.length > 0) {
        return dev[0]
      } else {
        return {}
      }
    },
    heatpump: function () {
      let dev = this.devicelist.filter((d) => {
        return d.type == 'heatpump'
      })
      if (dev && dev.length > 0) {
        return dev[0]
      } else {
        return {}
      }
    },
    acb: function () {
      let dev = this.devicelist.filter((d) => {
        return d.protocolid == 148
      })
      if (dev && dev.length > 0) {
        return dev[0]
      } else {
        return {}
      }
    },
    hkj: function () {
      let dev = this.devicelist.filter((d) => {
        return d.protocolid == 148
      })
      if (dev && dev.length > 0) {
        return dev[0]
      } else {
        return {}
      }
    }
  },
  mounted: function () {
    let project = window.localStorage.getItem('project')
    console.log(this.qlg)
    if (project) {
      this.project = JSON.parse(project)
      if(this.project.innerid != this.project.projectid) {
        this.project.innerid = this.project.projectid
      }
    } else {
      this.$router.push({ name: 'Login' })
      return
    }
    this.Common.connentMqtt(this.Common.newGuid())
    let self = this

    Vue.axios.post('/api/cchv/errorcode/list', {}).then((res) => {
      if (res.data.errcode == 0) {
        self.errorlist = res.data.msgbody.dev_errorcode
      }
    })

    Vue.axios
      .post('/api/cchv/device/list', {
        projectid: this.project.innerid
      })
      .then((res) => {
        if (res.data.errcode == 0) {
          // console.log(JSON.stringify(res.data))
          self.devicelist = res.data.msgbody
          if (this.acb.innerid) {
            Vue.axios.post('/api/cchv/power/query', {deviceid: this.acb.innerid}).then((res) => {
              if (res.data.errcode == 0) {
                self.power = res.data.msgbody
              }
            })
          }
          if (self.heatpump.innerid) {
            Vue.axios
              .post('/api/cchv/errorhistory/query', {
                deviceid: self.heatpump.innerid
              })
              .then((res) => {
                if (res.data.errcode == 0) {
                  self.gridData = res.data.msgbody
                }
              })
          }
          setTimeout(function () {
            self.Common.mqttReceive(
              [
                'device/' + self.project.srcaddress + '/broadcast',
                'device/' + self.project.srcaddress + '/' +
                  self.Common.mqttClientid
              ],
              function (msg) {
                // 主机只要收到消息就表明在线，70s内无消息则离线
                self.mibeeOnline = true
                if (self.onlineTimeout) {
                  clearTimeout(self.onlineTimeout)
                  self.onlineTimeout = null
                }
                self.onlineTimeout = setTimeout(function () {
                  self.mibeeOnline = false
                }, 70 * 1000)

                msg = JSON.parse(msg.payloadString)
                for (var key in msg) {
                  if (key == 'dpchange' || key == 'devdpmsg') {
                    self.uploadtime = new Date().Format('yyyy-MM-dd HH:mm:ss')
                    var dev = self.devicelist.filter((x) => {
                      if (key == 'dpchange') {
                        return x.deviceid == msg.dpchange.devid
                      } else {
                        return x.deviceid == msg.devdpmsg.devid
                      }
                    })
                    if (dev && dev.length > 0) {
                      if (msg.dpchange.dpid == 9000) {
                        dev[0].online = msg[key].data
                      } else if (msg.dpchange.dpid == 9003) {
                      } else if (msg.dpchange.dpid == 9009) {
                        console.log(msg.dpchange)
                        if (msg.dpchange.data == 0) {
                          dev[0].errmsg = ''
                        } else {
                          if (self.errorlist && self.errorlist.length > 0) {
                            let error = self.errorlist.filter((x) => {
                              return (
                                x.protocolid.indexOf(dev[0].protocolid) >= 0
                              )
                            })
                            if (error && error.length > 0) {
                              let err = error[0].errorlist.filter((e) => {
                                return e.code == msg.dpchange.data
                              })
                              if (err && err.length > 0) {
                                dev[0].errmsg = err[0].desc
                              } else {
                                dev[0].errmsg = '未知故障'
                              }
                            } else {
                              dev[0].errmsg = '未知故障'
                            }
                          } else {
                            dev[0].errmsg = '未知故障'
                          }
                        }
                      } else {
                        let dp = dev[0].dplist.filter((d) => {
                          return d.dpid == msg[key].dpid
                        })
                        if (dp && dp.length > 0) {
                          if (
                            dp[0].name == 'lgtpwr' ||
                            dp[0].name == 'lnrdimpwr'
                          ) {
                            dev[0].power = msg[key].data
                          }
                          dev[0][dp[0].name] =
                            Math.round(msg[key].data * 10) / 10
                        }
                      }
                    }
                  } else if (key == 'dpsync') {
                    msg.dpsync.forEach((o) => {
                      var dev = self.devicelist.filter((x) => {
                        return x.deviceid == o.devid
                      })
                      if (dev && dev.length > 0) {
                        for (let key in o.dplist) {
                          if (key == '9000') {
                            dev[0].online = o.dplist[key]
                          } else if (key == '9003') {
                            dev[0].signal = o.dplist[key]
                          } else {
                            let dp = dev[0].dplist.filter((d) => {
                              return d.dpid == parseInt(key)
                            })
                            if (dp && dp.length > 0) {
                              if (
                                dp[0].name == 'lgtpwr' ||
                                dp[0].name == 'lnrdimpwr'
                              ) {
                                dev[0].power = o.dplist[key]
                              }
                              dev[0][dp[0].name] =
                                Math.round(o.dplist[key] * 10) / 10
                            }
                          }
                        }
                      }
                    })
                  }
                }
              }
            )
            let obj = { getAllDevOnlineSta: {} }
            self.Common.mqttSend(
              self.project.srcaddress,
              obj,
              function (msg) {}
            )
            obj = { getAllDevAllDpSta: 'save' }
            self.Common.mqttSend(
              self.project.srcaddress,
              obj,
              function (msg) {}
            )
            obj = { sysheart: 'null' }
            self.Common.mqttSend(
              self.project.srcaddress,
              obj,
              function (msg) {}
            )
          }, 2000)
        }
      })
    if (self.project.pcity || self.project.city || (self.project.ip && self.project.ip != '127.0.0.1')) {
      Vue.axios.post('/api/weather', { weaid: (self.project.pcity || self.project.city || self.project.ip) }).then((res) => {
        if (res.data.errcode == 0) {
          self.outtemp = res.data.msgbody.temp
          self.outhumid = res.data.msgbody.humidity
          self.aqi = res.data.msgbody.aqi
        }
      })
    }
    setInterval(function () {
      let obj = { sysheart: 'null' }
      self.Common.mqttSend(
        self.project.srcaddress,
        obj,
        function (msg) {}
      )
    }, 30 * 1000)
  },
  methods: {
    showErrorList: function () {},
    calcHanZhi: function (t, h) {
      // 计算含湿量
      // d=622*(o*p/(B-o*p))

      // let p=0.07394*t^3-0.02*t^2+62.49*t+581.9;
      // let d=622*(h*p/(101325-h*p))
      // return Math.round((1.01*t+(1.84*t+2500)*d/1000)*100)/100;

      return Calcu_02(t, h, 101.325).h
    },
    calcHsl: function (t, h) {
      return Calcu_02(t, h, 101.325).d
    },
    calcRate (v1, v2, v3) {
      if (v1 - v3 == 0) {
        return 85
      }
      let val = Math.round(((v1 - v2) / (v1 - v3)) * 100)
      if (val <= 0 || val > 85) {
        return 85
      } else {
        return val
      }
    },
    calcRate2 (v1, v2) {
      return Math.round((v1 / v2) * 1000) / 10
    },
    getDpText: function (device, tag) {
      if(device.dplist){
              let dp = device.dplist.filter((d) => {
        return d.name == tag
      })
      if (dp && dp.length > 0) {
        let t = dp[0].options.filter((o) => {
          return o.value == device[tag]
        })
        if (t && t.length > 0) {
          return t[0].text
        } else {
          return '--'
        }
      } else {
        return '--'
      }
      }else{
        return '--'
      }

    }
  }
}

Date.prototype.Format = function (formatStr) {
  var str = formatStr
  var Week = ['日', '一', '二', '三', '四', '五', '六']

  str = str.replace(/yyyy|YYYY/, this.getFullYear())
  str = str.replace(
    /yy|YY/,
    this.getYear() % 100 > 9
      ? (this.getYear() % 100).toString()
      : '0' + (this.getYear() % 100)
  )

  str = str.replace(
    /MM/,
    this.getMonth() > 8 ? this.getMonth() + 1 : '0' + (this.getMonth() + 1)
  )
  str = str.replace(/M/g, this.getMonth())

  str = str.replace(/w|W/g, Week[this.getDay()])

  str = str.replace(
    /dd|DD/,
    this.getDate() > 9 ? this.getDate().toString() : '0' + this.getDate()
  )
  str = str.replace(/d|D/g, this.getDate())

  str = str.replace(
    /hh|HH/,
    this.getHours() > 9 ? this.getHours().toString() : '0' + this.getHours()
  )
  str = str.replace(/h|H/g, this.getHours())
  str = str.replace(
    /mm/,
    this.getMinutes() > 9
      ? this.getMinutes().toString()
      : '0' + this.getMinutes()
  )
  str = str.replace(/m/g, this.getMinutes())

  str = str.replace(
    /ss|SS/,
    this.getSeconds() > 9
      ? this.getSeconds().toString()
      : '0' + this.getSeconds()
  )
  str = str.replace(/s|S/g, this.getSeconds())

  return str
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.text {
  color: #929292;
  height: 16px;
  line-height: 16px;
}

.value {
  color: #eca714;
  height: 16px;
  line-height: 16px;
}

.text_big {
  color: #929292;
  height: 20px;
  line-height: 20px;
}

.value_big {
  color: #eca714;
  height: 20px;
  line-height: 20px;
  text-align: right;
}

::-webkit-scrollbar {
  width: 7px;
  height: 7px;
  background-color: #0c0404;
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #0c0404;
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  background-color: gray;
}
</style>



// WEBPACK FOOTER //
// src/components/Devices/CCH.vue